// @flow

export const checkPaymentMethodRequired = (plan: Object, promotionCode?: Object): boolean => {
  if (promotionCode?.metadata?.cardInfoRequired) return true;

  const discountPercentage = promotionCode ? promotionCode.coupon.percentOff : 0;
  const origTotalPrice = plan.unitAmount / 100;
  const totalPrice = discountPercentage > 0 ? (origTotalPrice * (100 - discountPercentage)) / 100 : origTotalPrice;

  return totalPrice !== 0;
};
